/**
 * Menu Events Dropdown Functionality
 * Handles the dropdown functionality for menu-events sections
 */

/**
 * Toggle dropdown functionality
 * @param {HTMLElement} target - The element to show/hide
 * @param {HTMLElement} trigger - The trigger element
 */
function toggleDropdown(target, trigger) {
	const isExpanded = target.classList.contains('show');
	const arrow = trigger.querySelector('.dropdown-arrow');
	
	if (isExpanded) {
		// Close
		target.classList.remove('show');
		trigger.setAttribute('aria-expanded', 'false');
		if (arrow) arrow.style.transform = 'rotate(0deg)';
	} else {
		// Open
		target.classList.add('show');
		trigger.setAttribute('aria-expanded', 'true');
		if (arrow) arrow.style.transform = 'rotate(180deg)';
	}
}

/**
 * Close other dropdowns
 * @param {HTMLElement} currentTarget - The current dropdown to keep open
 */
function closeOtherDropdowns(currentTarget) {
	const allDropdowns = document.querySelectorAll('.menu-dropdown-content');
	const allTriggers = document.querySelectorAll('.menu-dropdown-toggle');
	
	allDropdowns.forEach(function(dropdown) {
		if (dropdown !== currentTarget) {
			dropdown.classList.remove('show');
		}
	});
	
	allTriggers.forEach(function(trigger) {
		if (trigger.getAttribute('data-target') !== currentTarget.id) {
			trigger.setAttribute('aria-expanded', 'false');
			const arrow = trigger.querySelector('.dropdown-arrow');
			if (arrow) arrow.style.transform = 'rotate(0deg)';
		}
	});
}

/**
 * Close all dropdowns
 */
function closeAllDropdowns() {
	const allDropdowns = document.querySelectorAll('.menu-dropdown-content');
	const allTriggers = document.querySelectorAll('.menu-dropdown-toggle');
	
	allDropdowns.forEach(function(dropdown) {
		dropdown.classList.remove('show');
	});
	
	allTriggers.forEach(function(trigger) {
		trigger.setAttribute('aria-expanded', 'false');
		const arrow = trigger.querySelector('.dropdown-arrow');
		if (arrow) arrow.style.transform = 'rotate(0deg)';
	});
}

function init() {
	// Get all dropdown triggers
	const dropdownTriggers = document.querySelectorAll('.menu-dropdown-toggle');
	
	dropdownTriggers.forEach(function(trigger) {
		trigger.addEventListener('click', function(e) {
			e.preventDefault();
			
			// Get the target dropdown element
			const targetId = this.getAttribute('data-target');
			const targetElement = document.getElementById(targetId);
			
			if (!targetElement) {
				return;
			}
			
			// Close other dropdowns first
			closeOtherDropdowns(targetElement);
			
			// Toggle the current dropdown
			toggleDropdown(targetElement, this);
		});
	});

	// Close dropdowns when clicking outside
	document.addEventListener('click', function(e) {
		if (!e.target.closest('.menu-dropdown')) {
			closeAllDropdowns();
		}
	});
}

export default init;
